import React, { Component } from 'react';

import { Input } from 'semantic-ui-react';

import FieldWrapper from './fieldWrapper';

class CInputField extends Component {
  render() {
    const { onChange, value, key, type, placeholder, label, validation, error, errorMessage, onBlur, inputSub, popup, width, iconLabel, id, errorComponent, maxLength, hidden, disabled, justifyNullValues } = this.props;

    if (hidden) {
      return null;
    }

    return (
      <FieldWrapper label={label}
        key={key}
        validation={validation}
        error={error}
        errorMessage={errorMessage}
        onBlur={onBlur}
        inputSub={inputSub}
        popup={popup}
        value={value}
        width={width}
        errorComponent={errorComponent}
        justifyNullValues={justifyNullValues} >
        <Input id={id}
          onChange={onChange}
          maxLength={maxLength}
          value={value || ''}
          type={type}
          placeholder={placeholder}
          label={iconLabel}
          disabled={disabled} />
      </FieldWrapper>
    );
  }
}

export default CInputField;

